module.exports = __webpack_public_path__ + "img/D3M9_new.b028fbb2.jpg";